import React, { useEffect, useState } from 'react';

const CheckMark = ({ isChecked: isCheckedProp = false, onClick }) => {
  const [isChecked, setIsChecked] = useState(isCheckedProp);

  useEffect(() => {
    setIsChecked(isCheckedProp);
  }, [isCheckedProp]);

  const handleClick = () => {
    const newCheckedState = !isChecked;
    setIsChecked(newCheckedState);
    if (onClick) {
      onClick(newCheckedState);
    }
  };

  return (
    <div
      onClick={handleClick}
      className={`w-5 h-5 border cursor-pointer flex items-center justify-center 
        ${isChecked ? 'bg-contrast2 border-contrast1' : 'bg-white border-gray-300'}`}
    >
      {isChecked && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="w-4 h-4 text-white"
        >
          <polyline points="20 6 9 17 4 12" />
        </svg>
      )}
    </div>
  );
};

export default CheckMark;
